module.exports = __webpack_public_path__ + "img/sii-icon-dark.c6f398ac.svg";